import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Textarea } from '../components/ui/textarea';
import { Badge } from '../components/ui/badge';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../components/ui/select';
import JobCard from '../components/JobCard';
import { API_URL, formatDate, getStatusBadgeClass, licenseOptions } from '../lib/utils';
import { toast } from 'sonner';
import {
  Briefcase,
  Bookmark,
  FileText,
  User,
  Settings,
  Loader2,
  Upload,
  MapPin,
  Phone,
  Calendar,
  Building2,
  ExternalLink,
  Award,
  GraduationCap,
  Trash2,
  FileCheck,
  Archive,
  MessageSquare,
  Sparkles,
  CheckCircle2,
  AlertCircle,
} from 'lucide-react';
import MessagesPanel from '../components/MessagesPanel';
import { useJobSeekerCtx } from './JobSeekerContext';


const JobSeekerTabOverview = () => {
  const { applications, savedJobs } = useJobSeekerCtx();
  return (
    <>
            <div className="grid lg:grid-cols-2 gap-6">
              {/* Recent Applications */}
              <div className="bg-white rounded-xl p-6 border border-gray-100">
                <h3 className="font-semibold text-gray-900 mb-4">Recent Applications</h3>
                {applications.length > 0 ? (
                  <div className="space-y-4">
                    {applications.slice(0, 5).map((app) => (
                      <Link
                        key={app.application_id}
                        to={`/jobs/${app.job_id}`}
                        className="block p-3 rounded-lg hover:bg-gray-50 transition-colors"
                      >
                        <div className="flex justify-between items-start">
                          <div>
                            <h4 className="font-medium text-gray-900">{app.job?.title || 'Job'}</h4>
                            <p className="text-sm text-gray-500">{app.job?.company_name}</p>
                          </div>
                          <Badge className={getStatusBadgeClass(app.status)}>
                            {app.status.charAt(0).toUpperCase() + app.status.slice(1)}
                          </Badge>
                        </div>
                      </Link>
                    ))}
                  </div>
                ) : (
                  <p className="text-gray-500 text-center py-8">No applications yet</p>
                )}
              </div>

              {/* Saved Jobs Preview */}
              <div className="bg-white rounded-xl p-6 border border-gray-100">
                <h3 className="font-semibold text-gray-900 mb-4">Saved Jobs</h3>
                {savedJobs.length > 0 ? (
                  <div className="space-y-4">
                    {savedJobs.slice(0, 5).map((job) => (
                      <Link
                        key={job.job_id}
                        to={`/jobs/${job.job_id}`}
                        className="block p-3 rounded-lg hover:bg-gray-50 transition-colors"
                      >
                        <h4 className="font-medium text-gray-900">{job.title}</h4>
                        <p className="text-sm text-gray-500">{job.company_name}</p>
                      </Link>
                    ))}
                  </div>
                ) : (
                  <p className="text-gray-500 text-center py-8">No saved jobs</p>
                )}
              </div>
            </div>
    </>
  );
};

export default JobSeekerTabOverview;
